import { createFileRoute, Link } from "@tanstack/react-router";
import { AiQueriesPanel } from "@/components/admin/AiQueriesPanel";

export const Route = createFileRoute("/_authenticated/_admin/admin/ai-queries")({
  component: AiQueriesPage,
});

function AiQueriesPage() {
  return (
    <div style={{ padding: "2rem 1.5rem" }}>
      <div style={{ maxWidth: 880, margin: "0 auto 1.25rem", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h1 style={{ color: "var(--accent-cyan)", margin: 0 }}>KI-Fragen zur Matrix</h1>
        <Link to="/admin" style={{ color: "var(--text-muted)", textDecoration: "none", fontSize: "0.85rem" }}>
          Zurueck zum Dashboard
        </Link>
      </div>
      <div style={{ maxWidth: 880, margin: "0 auto" }}>
        <AiQueriesPanel />
      </div>
    </div>
  );
}
